<template>
  <v-card outlined>
    <v-container>
      <v-data-table
        :headers="reports_headers"
        :items="reports_table"
        :loading="reports_table.size == 0"
      >
      </v-data-table>
    </v-container>
  </v-card>
</template>
<script>
export default {
  name: "TableReports",
  props: {
    reports: Array
  },
  data() {
    return {
      headers: [
        //{ value: "object", text: "Object" },
        { value: "date", text: "Date" },
        { value: "owner", text: "Author" },
        { value: "report_type", text: "Type" },
        { value: "source", text: "Source" }
      ]
    };
  },
  mounted() {
    // console.log("mounted table", this.info)
  },
  computed: {
    reports_table: {
      get() {
        return this.reports;
      }
    },
    reports_headers: {
      get() {
        if (this.reports[0]) {
          let report = this.reports[0];
          let keys = Object.keys(report);
          keys = keys.forEach(x => {
            if (report[x] == null) delete report[x];
          });
          keys = Object.keys(report);
          return this.headers.filter(x => keys.includes(x.value));
        }
        return [];
      }
    }
  }
};
</script>
